import { excludeMetaItems, filterByMetaItems } from "../../common";

const graphUrl = "https://sofa-rest-api.azure-api.net/api/sofa/v1/graphql";
const uploadUrl = "https://sofa-rest-api.azure-api.net/api/sofa/v2/file";
const urlParams: URLSearchParams = new URLSearchParams(document.location.search.substring(1).replace(/%26/g, "&"));
const paramEnv = urlParams.get("environment");
export const apimSubscription = !paramEnv || paramEnv === ""? "56adc1842bac4d7c9ff71e8002b8f3cb" : paramEnv;

/* global fetch, console */

export const getDocTypes = async (token: string) => {
  const queryData = {
    query: `
      query getFileTypesWithActive($mode: DocPermDocStateType!) {
        docs {
          types(iHavePermissions: {stateType: $mode, create: CAN_CREATE}) {
            id
            displayName_Localization {
              cz
              en
            }
            schemaTypeName
            defaultView {
              id
              displayName
            }
          }
        }
      }`,
    variables: {
      mode: "ARCHIVE",
    },
  };
  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(queryData),
  });
};

export const getSystemTypes = async (token: string) => {
  const queryData = {
    query: `
    {
      company {
        users {
          value: id
          firstName
          lastName
          email
          __typename
        }
        __typename
      }
      enums {
        class {
          id
          values {
            displayName_Localization {cz en}
            value
            isHidden
          }
        }
        enums {
          id
          values {
            displayName_Localization {cz en}
            value
            isHidden
          }
        }
        rank {
          id
          values {
            displayName_Localization {cz en}
            value
            isHidden
          }
        }
      }
    }`,
    variables: {},
  };
  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(queryData),
  });
};

export const getDocTypeMetadata = async (token: string, typeId: string) => {
  const queryData = {
    query: `
      query getViewEditMetadata {
        docs {
          view(defaultForType: "${typeId}") {
            id
            metadata {
              displayName_Localization{
                en
                cz
              }
              types {
                docType {   id    }
                isRequired
              }
              format
              isReadonly
              metadataGrid {
                editFormVisibility
                row
                column
                __typename
              }
              meta {
                id
                dataType
                schemaFieldName
                isSystem
                schemaEnumValueName   
                defaultIsRequired
                dataTypeEnum {
                    id
                    __typename
                }
              }
            }
            __typename
          }
          __typename         
        }
      }`,
    variables: {},
  };
  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(queryData),
  });
};

export const uploadFile = async (token: string, file: Blob, fileName: string) => {
  const formData = new FormData();
  const fileNameObject = new String(fileName);
  const newFileName = fileNameObject.substring(0, fileNameObject.lastIndexOf(".")) + ".pdf" || fileName + ".pdf";
  formData.set("file", file, newFileName);

  return await fetch(uploadUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Disposition": encodeURI(fileName),
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: formData,
  });
};

export const submitDocument = async (token: string, fileId: string, docType: string, docTypeInfo: any) => {
  const metaDataFields = filterByMetaItems(docTypeInfo);
  const sysDataFields = excludeMetaItems(docTypeInfo);
  const data = {
    query: `
      mutation createDocument($values: [DocFile_${docType}_Create!]!) {
        docs {
          files {
            create${docType}Batch(values: $values) {
              sys {
                id
              }
            }
          }
        }
      }`,
    variables: {
      values: [
        {
          sys: {
            fileId: fileId,
            ...sysDataFields,
          },
          ...metaDataFields,
        },
      ],
    },
  };
  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(data),
  });
};

// TODO pro spustit agendu vrátit canStart a messageIdent
export const getAgendaList = async (token: string) => {
  const data = {
    query: `
      query getAgendas($canStart: Boolean, $messageIdent: Guid) {
          processes {
              agendas(canStart: $canStart, messageIdent: $messageIdent) {
                id
                tdId
                displayName
                description
                createAgendaInstanceLink
                icon
                iconColor
                order
                __typename
              }
          __typename
        }
      }`,
    variables: {
      canStart: true,
      messageIdent: "BA4BF472-79B8-4427-A35F-966509C561C6"
    }
  };
  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(data),
  });
};

export const startAgenda = async (token: string, agendaId: string, fileIds: string[], messageIdent: string) => {
  const data = {
    query: `mutation startAgenda
      (
        $messageIdent:String!,
        $agendaIdent:String!,
        $fileIds: [File_Id!],
        $duplicateFiles:Boolean!
      )
      {
      processes{
          sendMessageToAgendaEx
          (
            messageIdent:$messageIdent
            agendaIdent:$agendaIdent
            duplicateFiles: $duplicateFiles
            fileIds:$fileIds
          )
          {
            instance{
              id
              agendaName
              instanceIdent
              state
              version
              modifiedTime
              createdByExtIs{
                displayName
                id
              }
              createdByUser{
                completeName
                id
              }
              variables {
                name
                type
                valueString
              }
            }
            url
          }
        } 
      }`,
    variables: {
      messageIdent: messageIdent? messageIdent : "sys_obecna_dms_zprava",
      agendaIdent: agendaId,
      duplicateFiles: true,
      fileIds: fileIds,
    },
  };

  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(data),
  });
};

export const sendMessageToAgenda = async (token: string, agendaId: string, fileIds: string[]) => {
  const data = {
    operationName: "sendMessageToAgenda",
    variables: {
      messageIdent: "BA4BF472-79B8-4427-A35F-966509C561C6",
      agendaIdent: agendaId,
      fileIds: fileIds,
    },
    query: `
          mutation sendMessageToAgenda($messageIdent: Guid!, $agendaIdent: Guid!, $fileIds: [Guid!]!) {
            docs {
              files {
                forwardFilesToAgenda(
                messageIdent: $messageIdent,
                agendaIdent: $agendaIdent,
                fileIds: $fileIds) {
                  url
        }
        url
      }
      }
    }`,
  };
  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(data),
  });
};

export const getSignedAgenda = (token: string, operationUrl: string): Promise<any> => {
  return fetch(operationUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
  })
    .then((response) => {
      if (response.status === 401 || response.status === 403) {
        return fetch(operationUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": apimSubscription,
          },
        }).then((resp) => {
          return resp.json();
        });
      } else {
        return response.json();
      }
    })
    .catch((err) => console.error(err));
};

export const downloadSignedAgenda = (token: string, signedFileId: string): Promise<any> => {
  return fetch("https://sofa-rest-api.azure-api.net/api/sofa/v2/file?fileId=" + signedFileId, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Ocp-Apim-Subscription-Key": apimSubscription,
      "Ocp-Apim-Trace": "false",
    },
  })
    .then((response) => {
      return response.blob();
    })
    .catch((err) => console.error(err));
};

export const getCompanyInfo = async (token: string) => {
  const data = {
    operationName: "getCompanyInfo",
    variables: {},
    query: `
          query getCompanyInfo {
            company {
              info {
                agendas {
                  signPoint 
                }
              }
            }
          }`,
  };
  return await fetch(graphUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "Ocp-Apim-Subscription-Key": apimSubscription,
    },
    body: JSON.stringify(data),
  });
};
